module.exports = __webpack_public_path__ + "img/branded_qr_codes.57f5d37e.png";